// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';

// Interne Module
import * as storage from '@/_helper/storage';
import { checkIsAllowToBookService } from '@/_helper/checkAccess';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import HeroTeaser from '@/comp/heroTeaser';
import PaymentRefund from '@/comp/paymentRefund/PaymentRefund';
import { BackButton } from '@/comp/backButton/backButton';

// Styles
import './paymentRefund.scss';

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : {},
            bookingParams:
                storage.get('bookingData') !== null && storage.get('bookingData').bookingParams !== undefined
                    ? storage.get('bookingData').bookingParams
                    : '',
            paymenttypes: {
                directDebit: {
                    title: 'Lastscrift',
                },
                creditCard: {
                    title: 'Kreditkarte',
                },
            },
            paymentRefundData: {},
            formValid: false,
            formVacancy: false,
            formSubmit: false,
            hasAlreadyTested: false,
            refundSuccess: false,
            error: false,
        };

        this.getPaymentChange = this.getPaymentChange.bind(this);
        this.hasAlreadyTested = this.hasAlreadyTested.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = 'Rückzahlung' + window.$documentTitle;

        // already booked
        if (
            checkIsAllowToBookService('paymentRefund') &&
            this.state.bookingData?.data?.allowedInteractions?.payment.refund === true
        ) {
            document.querySelector('html').classList.add('redesign');
        } else {
            window.location.href = '#/';
            window.location.reload();
        }
    }

    getPaymentChange(c) {
        this.setState({
            paymentRefundData: c,
        });

        if (c.valid) {
            this.setState({
                formValid: true,
            });
        } else {
            this.setState({
                formValid: false,
            });
        }
    }

    hasAlreadyTested(alreadyTested) {
        this.setState({
            hasAlreadyTested: alreadyTested,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        // error
        this.hasAlreadyTested(true);

        let $this = this;

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            return;
        }

        // form is valid!
        let sendParams = {
            requestType: 'bookingData',
            clientId: 'customerarea',
            requestSource: 'AurumTours-Customerarea',
            bookingId: storage.get('bookingNumber'),
            action: 'updatePayment',
            hash: storage.get('access_token'),
            paymentData: {
                paymentDataType: 'directDebit',
                accountOwner: $this.state.paymentRefundData.data.accountOwner,
                accountNumber: $this.state.paymentRefundData.data.accountNumber,
            },
        };

        this.setState({
            formVacancy: true,
            error: false,
        });

        axios({
            url: window.$serviceUrl + '/bookingData?token=' + window.$token,
            method: 'POST',
            data: sendParams,
        })
            .then((response) => response)
            .then(function (response) {
                if (response.data.data.data.updated === true) {
                    $this.setState({
                        refundSuccess: true,
                        formVacancy: false,
                    });

                    // add booked service
                    let bookedService;
                    if (storage.get('bookingData').bookedService === undefined) {
                        bookedService = { bookedService: {} };
                    } else {
                        bookedService = storage.get('bookingData');
                    }

                    bookedService.bookedService['paymentRefund'] = {
                        data: {
                            success: true,
                        },
                    };

                    storage.set('bookingData', _.assign(storage.get('bookingData'), bookedService));
                }
            })
            .catch((error) => {
                let $this = this;

                $this.setState({
                    error: true,
                    formVacancy: false,
                });
            });
    }

    render() {
        return (
            <div className="page-refund">
                <Header />

                <HeroTeaser />

                <div className="content-wrapper">
                    {!this.state.refundSuccess ? (
                        <form
                            className={this.state.formVacancy ? 'validate' : ''}
                            autoComplete="off"
                            onSubmit={this.handleSubmit}
                            method="post"
                            noValidate="">
                            <div className="intro row">
                                <h1 className="main-headline col">Ihre Bankverbindung zur Auszahlung</h1>
                            </div>

                            <div className="row entry">
                                <PaymentRefund
                                    paymenttypes={this.state.paymenttypes}
                                    hasAlreadyTested={this.state.hasAlreadyTested}
                                    getPaymentChange={this.getPaymentChange}
                                />

                                <hr />

                                <div className="accept-sec">
                                    Mit Klick auf "Bankverbindung übermitteln" bestätigen Sie die Kenntnisnahme der{' '}
                                    <a
                                        href={`${window.$website}/unternehmen/agb`}
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        AGB
                                    </a>{' '}
                                    von AurumTours, sowie der{' '}
                                    <a
                                        href={`${window.$website}/unternehmen/datenschutz/vorabinformationen-datenschutz`}
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        Vorab-Informationen zum Datenschutz
                                    </a>
                                    .
                                </div>
                            </div>

                            <div className="user-action">
                                <BackButton class="col" target="blank" />

                                <button
                                    className={
                                        'col ' +
                                        (this.state.formValid ? 'valid ' : 'invalid ') +
                                        (this.state.formVacancy ? 'validate' : '')
                                    }
                                    type="submit"
                                    // disabled={!this.state.formValid}
                                >
                                    {this.state.formVacancy ? (
                                        <span>Daten werden übermittelt ...</span>
                                    ) : (
                                        <span>Bankverbindung übermitteln</span>
                                    )}

                                    <i className="material-icons">arrow_forward</i>

                                    <span className="loader"></span>
                                </button>
                            </div>

                            {this.state.error && (
                                <div
                                    className={'error txtL'}
                                    dangerouslySetInnerHTML={{
                                        __html: window.$content.errorPaymentText.default,
                                    }}></div>
                            )}
                        </form>
                    ) : (
                        <div className="success-case">
                            <h3 className="heading">Vielen Dank, wir haben Ihre Bankverbindung erhalten.</h3>

                            <BackButton class="col button valid link" target="blank" />
                        </div>
                    )}
                </div>

                <Footer />
            </div>
        );
    }
}

export default Index;
